import { PageNotFound as DefaultPageNotFound } from "./components/PageNotFound";
// const DefaultPageNotFound = () => "Page Not Found";

export const onInitService = ({ createExtension, setContext, getConfig }) => {
  const routeItems = createExtension.sync("$ONE_LAYOUT_ROUTE").map((_) => _[0]);

  const { value: title } = createExtension.waterfall(
    "$ONE_LAYOUT_TITLE",
    getConfig("one.layout.title", "Demo App")
  );

  const contentLeft = createExtension
    .sync("$ONE_TOOLBAR_CONTENT_LEFT")
    .map(($) => $[0]);

  const contentRight = createExtension
    .sync("$ONE_TOOLBAR_CONTENT_RIGHT")
    .map(($) => $[0]);

  const routesBefore = createExtension
    .sync("$ONE_LAYOUT_ROUTES_BEFORE")
    .map(($) => $[0]);

  const routesAfter = createExtension
    .sync("$ONE_LAYOUT_ROUTES_AFTER")
    .map(($) => $[0]);

  const { value: PageNotFound } = createExtension.waterfall(
    "$ONE_LAYOUT_404",
    getConfig("one.layout.404", { component: DefaultPageNotFound })
  );

  const content = createExtension
    .sync("$ONE_LAYOUT_NAV_CONTENT")
    .map(($) => $[0]);

  const { value: open } = createExtension.waterfall(
    "$ONE_LAYOUT_NAV_OPEN",
    getConfig("one.layout.nav.open", false)
  );

  const { value: hidden } = createExtension.waterfall(
    "$ONE_LAYOUT_NAV_HIDDEN",
    getConfig("one.layout.nav.hidden", false)
  );

  const embedParamKey = getConfig("one.layout.embed.param.key", "embed");

  setContext("one.layout", {
    404: PageNotFound,
    baseName: getConfig("one.layout.baseName", "/"),
    routes: {
      items: routeItems,
      before: routesBefore,
      after: routesAfter
    },
    toolbar: {
      contentLeft,
      contentRight
    },
    nav: {
      content,
      open,
      hidden
    },
    title,
    embed: {
      param: {
        key: embedParamKey
      }
    }
  });
};
